export const API_URL = 'https://api.linksync.in/';
export const LINK_DOMAIN = 'lnksnc.in/';
export const LINK_URL = 'https://lnksnc.in/';
export const AUTH_FAIL_REDIRECT_URL = '/login';
export const AUTH_SUCCESS_REDIRECT_URL = '/dashboard';
export const ACCESS_TOKEN_LOCAL_STORAGE_KEY = 'linksync-access-token';